import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { PageHeader } from "@/components/PageHeader";
import { StatusBadge } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";

export default function Assets() {
  const { role } = useApp();
  const [assets, setAssets] = useState([]);
  const [q, setQ] = useState("");
  const load = () => api.get("/assets").then(({ data }) => setAssets(data));
  useEffect(() => { load(); }, []);

  const doReturn = async (id) => {
    try { await api.put(`/assets/${id}/return`, { _user: role }); toast.success("Asset marked returned"); load(); }
    catch (e) { toast.error("Failed"); }
  };

  const filtered = assets.filter((a) => !q || a.dp_name?.toLowerCase().includes(q.toLowerCase()) || a.fe_id?.includes(q) || a.asset.toLowerCase().includes(q.toLowerCase()));
  const stats = ["Delivery Bag", "T-Shirt", "Raincoat", "Helmet", "Gloves", "Mobile Holder"].map((t) => ({ t, n: assets.filter((a) => a.asset === t).length }));

  return (
    <div>
      <PageHeader title="Asset Management" subtitle="Bags, T-shirts, raincoats & equipment issued to partners" />
      <div className="mb-4 grid grid-cols-3 gap-3 sm:grid-cols-6">
        {stats.map((s) => <div key={s.t} className="rounded-xl border border-border bg-card p-3 text-center"><p className="font-head text-xl font-bold">{s.n}</p><p className="text-[11px] text-muted-foreground">{s.t}</p></div>)}
      </div>
      <Input placeholder="Search DP / FE ID / asset…" value={q} onChange={(e) => setQ(e.target.value)} className="mb-4 max-w-xs" data-testid="asset-search" />
      <div className="overflow-hidden rounded-xl border border-border bg-card">
        <Table>
          <TableHeader><TableRow className="hover:bg-transparent"><TableHead>DP</TableHead><TableHead>Asset</TableHead><TableHead>Qty</TableHead><TableHead>Issued</TableHead><TableHead>Condition</TableHead><TableHead>Return Req.</TableHead><TableHead>Status</TableHead><TableHead></TableHead></TableRow></TableHeader>
          <TableBody>
            {filtered.map((a) => (
              <TableRow key={a.id} data-testid={`asset-row-${a.id}`}>
                <TableCell className="font-semibold">{a.dp_name}<span className="ml-1 font-mono text-xs text-muted-foreground">{a.fe_id}</span></TableCell>
                <TableCell>{a.asset}</TableCell><TableCell>{a.quantity}</TableCell><TableCell>{fmtDate(a.issue_date)}</TableCell><TableCell>{a.condition}</TableCell>
                <TableCell>{a.return_required ? "Yes" : "No"}</TableCell><TableCell><StatusBadge status={a.status} /></TableCell>
                <TableCell>{a.status === "Issued" && a.return_required && <Button size="sm" variant="outline" onClick={() => doReturn(a.id)} data-testid={`asset-return-${a.id}`}>Mark Returned</Button>}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
